// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___0612ce61428918d1761","cls2":"Comments-cls2__df4dc9d8f0941442d3e3 Comments-cls1___0612ce61428918d1761"};